import { useNotify, useUpdate } from "react-admin";
import { useMutation } from "react-query";
import { useNavigate, useParams } from "react-router-dom";

import * as Axios from "providers/axios";
import * as User from "providers/user";
import { toBase64 } from "utils/files";
import { Dispatch, SetStateAction } from "react";

export function usePhotoUploadSubmitEdit({
  keys,
  redirect,
  resource,
  setIsLoading
}: {
  keys: string[];
  redirect: string;
  resource: string;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
}) {
  const navigate = useNavigate();
  const { api } = Axios.useAxios();
  const { getUser } = User.useUser();
  const params = useParams();

  const mutation = useMutation((payload: { image: string }): any =>
    api.post(`/v1/uploads/image`, payload)
  );
  const [update] = useUpdate();
  const notify = useNotify();

  const onSubmit = async (payload: any, customOnSuccess?: any) => {
    if (setIsLoading) {
      setIsLoading(true);
    }
    const { id, created_at, updated_at, owner, owner_id, ...rest } = payload;
    let finalPayload = rest;

    try {
      await Promise.all(
        keys.map(async (key: string) => {
          if (payload?.[key]?.rawFile) {
            const image = (await toBase64(payload?.[key]?.rawFile)) as string;
            const { data } = (await mutation.mutateAsync({ image })) as any;

            finalPayload = {
              ...finalPayload,
              [key]: data.url
            };
          }
        })
      );
    } catch (e) {
      notify("An error occurred while uploading images.", {
        type: "error",
        undoable: false,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        duration: 5000
      });
      if (setIsLoading) {
        setIsLoading(false);
      }
      return;
    }
    update(
      resource,
      {
        id: params.id,
        data: finalPayload
      },
      {
        onSuccess: customOnSuccess
          ? (userData) => customOnSuccess(userData)
          : () => {
              if (setIsLoading) {
                setIsLoading(false);
              }
              getUser();
              navigate(redirect);
            },
        onError: () => {
          if (setIsLoading) {
            setIsLoading(false);
          }
        }
      }
    );
  };

  return {
    submit: onSubmit
  };
}
